export const appConfig = {
    api: {
        url: "https://secureportal-central-prod-aps.azurewebsites.net"
    },
    auth: {
        groupId: "b83cea81-f4b0-445a-81be-c758742c01ca"
    }
};